import { render, staticRenderFns } from "./ComprehensiveResultsCard.vue?vue&type=template&id=b90e0af8&scoped=true&"
import script from "./ComprehensiveResultsCard.vue?vue&type=script&lang=js&"
export * from "./ComprehensiveResultsCard.vue?vue&type=script&lang=js&"
import style0 from "./ComprehensiveResultsCard.vue?vue&type=style&index=0&id=b90e0af8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90e0af8",
  null
  
)

export default component.exports